import { render, staticRenderFns } from "./postManager.vue?vue&type=template&id=8dc8b05a&"
import script from "./postManager.vue?vue&type=script&lang=js&"
export * from "./postManager.vue?vue&type=script&lang=js&"
import style0 from "./postManager.vue?vue&type=style&index=0&id=8dc8b05a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports